const SCROLL_ANIMATION_TRIGGER_CLASSNAME="scroll-trigger",SCROLL_ANIMATION_OFFSCREEN_CLASSNAME="scroll-trigger--offscreen",SCROLL_ZOOM_IN_TRIGGER_CLASSNAME="animate--zoom-in",SCROLL_ANIMATION_CANCEL_CLASSNAME="scroll-trigger--cancel";function onIntersection(elements,observer){elements.forEach((element,index)=>{if(element.isIntersecting){const elementTarget=element.target;elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)&&(elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME),elementTarget.hasAttribute("data-cascade")&&elementTarget.setAttribute("style",`--animation-order: ${index};`)),observer.unobserve(elementTarget)}else element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME),element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME)})}function initializeScrollAnimationTrigger(rootEl=document,isDesignModeEvent=!1){const animationTriggerElements=Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));if(animationTriggerElements.length===0)return;if(isDesignModeEvent){animationTriggerElements.forEach(element=>{element.classList.add("scroll-trigger--design-mode")});return}const observer=new IntersectionObserver(onIntersection,{rootMargin:"0px 0px -50px 0px"});animationTriggerElements.forEach(element=>observer.observe(element))}function initializeScrollZoomAnimationTrigger(){if(window.matchMedia("(prefers-reduced-motion: reduce)").matches)return;const animationTriggerElements=Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));if(animationTriggerElements.length===0)return;const scaleAmount=.2/100,visibleElements=new Set,observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{entry.isIntersecting?visibleElements.add(entry.target):visibleElements.delete(entry.target)})});animationTriggerElements.forEach(element=>{observer.observe(element),element.style.setProperty("--zoom-in-ratio",1+scaleAmount*percentageSeen(element))}),window.addEventListener("scroll",throttle(()=>{visibleElements.forEach(element=>{element.style.setProperty("--zoom-in-ratio",1+scaleAmount*percentageSeen(element))})},16),{passive:!0})}function percentageSeen(element){const viewportHeight=window.innerHeight,scrollY=window.scrollY,elementPositionY=element.getBoundingClientRect().top+scrollY,elementHeight=element.offsetHeight;if(elementPositionY>scrollY+viewportHeight)return 0;if(elementPositionY+elementHeight<scrollY)return 100;let percentage=(scrollY+viewportHeight-elementPositionY)/((viewportHeight+elementHeight)/100);return Math.round(percentage)}window.addEventListener("DOMContentLoaded",()=>{initializeScrollAnimationTrigger(),initializeScrollZoomAnimationTrigger()}),Shopify.designMode&&(document.addEventListener("shopify:section:load",event=>initializeScrollAnimationTrigger(event.target,!0)),document.addEventListener("shopify:section:reorder",()=>initializeScrollAnimationTrigger(document,!0)));
/* AZ YACHIR V4 — true scroll-driven book journey.
   Uses only existing Shopify product data and decorative book geometry. */
(() => {
  const SOURCE_SELECTOR = '.az-books-section:not(az-book-journey)';
  const CARD_SELECTOR = '.az-book-card';
  const STYLE_ID = 'az-book-journey-v41-styles';
  const STYLE_TEXT = "/* AZ YACHIR V4.1 — preserve the real 3D transform and present each product as a book, not a white card. */\naz-book-journey .az-book-card {\n  --az-cover-height: clamp(300px, 42svh, 450px);\n  width: clamp(240px, 21vw, 320px) !important;\n  border: 0 !important;\n  background: transparent !important;\n  box-shadow: 0 0 calc(58px * var(--az-active, 0)) rgba(226, 181, 80, 0.42) !important;\n  transform: var(--az-transform, translate(-50%, -50%)) !important;\n}\n\naz-book-journey .az-book-card:hover,\naz-book-journey .az-book-card:focus-within {\n  transform: var(--az-transform, translate(-50%, -50%)) !important;\n}\n\naz-book-journey .az-book-card__back {\n  inset: 5px 4px auto !important;\n  height: calc(var(--az-cover-height) - 10px) !important;\n}\n\naz-book-journey .az-book-card__spine {\n  top: 4px !important;\n  bottom: auto !important;\n  height: calc(var(--az-cover-height) - 8px) !important;\n}\n\naz-book-journey .az-book-card__colorband {\n  bottom: auto !important;\n  height: var(--az-cover-height) !important;\n}\n\naz-book-journey .az-book-card__img {\n  height: var(--az-cover-height) !important;\n  padding: 0 !important;\n  overflow: visible !important;\n  border-radius: 17px 6px 18px 7px !important;\n  background: transparent !important;\n}\n\naz-book-journey .az-book-card__img::before {\n  content: \"\";\n  position: absolute;\n  z-index: 0;\n  inset: 8% 3% 4%;\n  border-radius: 50%;\n  background: radial-gradient(ellipse, rgba(255, 228, 159, calc(.28 * var(--az-active, 0))), transparent 68%);\n  filter: blur(18px);\n  pointer-events: none;\n}\n\naz-book-journey .az-book-card__img img {\n  position: relative;\n  z-index: 2;\n  filter: brightness(1.06) saturate(1.06) contrast(1.02) !important;\n mix-blend-mode: multiply;\n border-radius: 22px 7px 24px 9px !important;\n}\n\naz-book-journey .az-book-card__back,\n az-book-journey .az-book-card__spine,\n az-book-journey .az-book-card__colorband {\n display: none !important;\n }\n\n az-book-journey .az-book-card__info {\n  min-height: 106px;\n  margin-top: 14px;\n  border: 1px solid rgba(160, 105, 25, 0.18) !important;\n  border-radius: 18px 6px 18px 6px !important;\n  background: rgba(255, 253, 248, 0.93) !important;\n  box-shadow: 0 16px 34px rgba(77, 49, 15, 0.12);\n  -webkit-backdrop-filter: blur(14px);\n  backdrop-filter: blur(14px);\n}\n\naz-book-journey.az-books-section .az-books-grid {\n isolation: isolate !important;\n background: #fffaf0 !important;\n }\n\n @media screen and (max-width: 989px) {\n  az-book-journey .az-book-card {\n    --az-cover-height: min(54svh, 410px);\n  }\n\n  az-book-journey .az-book-card__img {\n    height: var(--az-cover-height) !important;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  az-book-journey .az-book-card,\n  az-book-journey .az-book-card:hover,\n  az-book-journey .az-book-card:focus-within {\n    transform: none !important;\n  }\n}\n";
  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = STYLE_TEXT;
    document.head.appendChild(style);
  };
  ensureStyles();
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  class AzBookJourney extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return;
      this._mounted = true;

      this.cards = Array.from(this.querySelectorAll(CARD_SELECTOR));
      this.grid = this.querySelector('.az-books-grid');
      this.header = this.querySelector('.az-section-header');
      if (!this.grid || this.cards.length < 2) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.current = 0;
      this.target = 0;
      this.activeIndex = -1;
      this.isVisible = true;
      this.isDesktop = false;
      this.raf = 0;
      this.lastFrame = 0;

      this.buildStructure();
      this.decorateBooks();
      this.buildNavigation();

      this.onPageScroll = () => this.requestFrame();
      this.onRailScroll = () => this.renderMobile();
      this.onResize = () => this.measure(true);
      this.onMotionChange = () => this.measure(true);

      window.addEventListener('scroll', this.onPageScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.grid.addEventListener('scroll', this.onRailScroll, { passive: true });
      this.reducedMotion.addEventListener?.('change', this.onMotionChange);

      this.resizeObserver = new ResizeObserver(() => this.measure(false));
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.pin);

      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          this.isVisible = entries.some((entry) => entry.isIntersecting);
          if (this.isVisible) this.requestFrame();
        },
        { rootMargin: '35% 0px 35% 0px' }
      );
      this.intersectionObserver.observe(this);

      this.measure(true);
    }

    disconnectedCallback() {
      if (!this._mounted) return;
      cancelAnimationFrame(this.raf);
      window.removeEventListener('scroll', this.onPageScroll);
      window.removeEventListener('resize', this.onResize);
      this.grid?.removeEventListener('scroll', this.onRailScroll);
      this.reducedMotion?.removeEventListener?.('change', this.onMotionChange);
      this.resizeObserver?.disconnect();
      this.intersectionObserver?.disconnect();
      this._mounted = false;
    }

    buildStructure() {
      this.pin = document.createElement('div');
      this.pin.className = 'az-books-pin';

      const children = Array.from(this.children);
      children.forEach((child) => this.pin.appendChild(child));
      this.appendChild(this.pin);
      this.classList.remove('az-scroll-stage');
      this.classList.add('az-book-journey');
      this.removeAttribute('data-az-scroll-mounted');
      this.style.removeProperty('--az-scroll-distance');
    }

    decorateBooks() {
      this.cards.forEach((card, index) => {
        card.style.removeProperty('transform');
        card.style.removeProperty('--az-transform');
        card.style.removeProperty('opacity');
        card.style.removeProperty('z-index');
        card.style.removeProperty('pointer-events');
        card.classList.remove('is-az-active');
        card.dataset.azIndex = String(index);

        if (!card.querySelector('.az-book-card__back')) {
          const back = document.createElement('span');
          back.className = 'az-book-card__back';
          back.setAttribute('aria-hidden', 'true');
          card.prepend(back);
        }

        if (!card.querySelector('.az-book-card__spine')) {
          const spine = document.createElement('span');
          spine.className = 'az-book-card__spine';
          spine.setAttribute('aria-hidden', 'true');
          card.prepend(spine);
        }

        const image = card.querySelector('img');
        if (image && index === 0) {
          image.loading = 'eager';
          image.fetchPriority = 'high';
        }
      });
    }

    buildNavigation() {
      this.meter = document.createElement('nav');
      this.meter.className = 'az-scroll-meter';
      this.meter.setAttribute('aria-label', document.documentElement.dir === 'rtl' ? 'ניווט בין הספרים' : 'Book navigation');

      this.previousButton = this.makeArrow('previous', '‹');
      this.meter.appendChild(this.previousButton);

      this.dots = this.cards.map((card, index) => {
        const dot = document.createElement('button');
        const title = card.querySelector('.az-book-card__title')?.textContent?.trim() || `${index + 1}`;
        dot.type = 'button';
        dot.className = 'az-scroll-dot';
        dot.setAttribute('aria-label', title);
        dot.addEventListener('click', () => this.goTo(index));
        this.meter.appendChild(dot);
        return dot;
      });

      this.nextButton = this.makeArrow('next', '›');
      this.meter.appendChild(this.nextButton);
      this.pin.appendChild(this.meter);
    }

    makeArrow(direction, glyph) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `az-journey-arrow az-journey-arrow--${direction}`;
      button.textContent = glyph;
      button.setAttribute('aria-label', direction === 'previous' ? 'Previous book' : 'Next book');
      button.addEventListener('click', () => {
        const delta = direction === 'previous' ? -1 : 1;
        this.goTo(clamp(Math.round(this.current) + delta, 0, this.cards.length - 1));
      });
      return button;
    }

    measure(force) {
      const nextDesktop = window.innerWidth >= 990 && !this.reducedMotion.matches;
      const modeChanged = nextDesktop !== this.isDesktop;
      this.isDesktop = nextDesktop;

      const pinTop = clamp(Math.round(window.innerHeight * 0.085), 64, 88);
      this.style.setProperty('--az-pin-top', `${pinTop}px`);
      this.pinTop = pinTop;

      if (this.isDesktop) {
        const pinHeight = Math.max(610, window.innerHeight - pinTop);
        const step = clamp(window.innerHeight * 0.58, 430, 640);
        const journeyHeight = pinHeight + (this.cards.length - 1) * step;
        this.style.setProperty('--az-journey-height', `${Math.round(journeyHeight)}px`);
        this.travel = Math.max(1, journeyHeight - pinHeight);
        this.sectionTop = this.getBoundingClientRect().top + window.scrollY;
        this.grid.scrollLeft = 0;
        if (modeChanged || force) this.current = this.readTarget();
        this.requestFrame();
      } else {
        this.style.removeProperty('--az-journey-height');
        this.cards.forEach((card) => {
          card.style.removeProperty('opacity');
          card.style.removeProperty('z-index');
          card.style.removeProperty('pointer-events');
        });
        requestAnimationFrame(() => this.renderMobile());
      }
    }

    readTarget() {
      if (!this.isDesktop) return this.current;
      const rect = this.getBoundingClientRect();
      const travel = Math.max(1, this.offsetHeight - this.pin.offsetHeight);
      this.travel = travel;
      const progress = clamp((this.pinTop - rect.top) / travel, 0, 1);
      return progress * (this.cards.length - 1);
    }

    requestFrame() {
      if (!this.isDesktop || !this.isVisible || this.raf) return;
      this.target = this.readTarget();
      this.raf = requestAnimationFrame((time) => this.renderDesktop(time));
    }

    renderDesktop(time) {
      this.raf = 0;
      const deltaTime = this.lastFrame ? Math.min(0.05, (time - this.lastFrame) / 1000) : 0.016;
      this.lastFrame = time;
      this.target = this.readTarget();
      const damping = 1 - Math.exp(-13 * deltaTime);
      this.current += (this.target - this.current) * damping;

      const sceneWidth = this.grid.clientWidth || window.innerWidth;
      const rtlDirection = document.documentElement.dir === 'rtl' ? -1 : 1;

      this.cards.forEach((card, index) => {
        const distanceSigned = index - this.current;
        const distance = Math.abs(distanceSigned);
        const direction = Math.sign(distanceSigned) || 0;
        const xMagnitude = Math.min(
          sceneWidth * 0.43,
          sceneWidth * (0.205 * distance + 0.045 * distance * distance)
        );
        const x = rtlDirection * direction * xMagnitude;
        const y = Math.min(48, distance * 17);
        const z = -Math.min(720, Math.pow(distance, 0.88) * 250);
        const rotateY = -rtlDirection * clamp(distanceSigned * 42, -72, 72);
        const rotateZ = clamp(distanceSigned * 1.4, -4.5, 4.5);
        const scale = Math.max(0.56, 1 - distance * 0.15);
        const opacity = distance > 2.75 ? 0 : Math.max(0.12, 1 - distance * 0.27);
        const detailOpacity = clamp((0.72 - distance) * 3, 0, 1);

        card.style.setProperty('--az-transform', `translate(-50%, -50%) translate3d(${x}px, ${y}px, ${z}px) rotateY(${rotateY}deg) rotateZ(${rotateZ}deg) scale(${scale})`);
        card.style.opacity = String(opacity);
        card.style.zIndex = String(1000 - Math.round(distance * 100));
        card.style.pointerEvents = distance < 0.48 ? 'auto' : 'none';
        card.style.setProperty('--az-detail-opacity', String(detailOpacity));
        card.style.setProperty('--az-active', String(clamp(1 - distance, 0, 1)));
      });

      this.setActive(Math.round(this.current));

      if (Math.abs(this.target - this.current) > 0.0015) {
        this.raf = requestAnimationFrame((nextTime) => this.renderDesktop(nextTime));
      }
    }

    renderMobile() {
      if (this.isDesktop || !this.grid) return;
      const railRect = this.grid.getBoundingClientRect();
      const railCenter = railRect.left + railRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      this.cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.left + rect.width / 2;
        const normalized = (cardCenter - railCenter) / Math.max(1, rect.width);
        const absolute = Math.abs(normalized);
        const rotateY = clamp(normalized * -18, -20, 20);
        const scale = 1 - Math.min(absolute * 0.08, 0.08);

        card.style.setProperty('--az-transform', `perspective(1000px) rotateY(${rotateY}deg) scale(${scale})`);
        card.style.setProperty('--az-detail-opacity', '1');
        card.style.setProperty('--az-active', String(clamp(1 - absolute, 0, 1)));

        if (absolute < closestDistance) {
          closestDistance = absolute;
          closestIndex = index;
        }
      });

      this.current = closestIndex;
      this.target = closestIndex;
      this.setActive(closestIndex);
    }

    setActive(index) {
      const safeIndex = clamp(index, 0, this.cards.length - 1);
      if (safeIndex === this.activeIndex) return;
      this.activeIndex = safeIndex;

      this.cards.forEach((card, cardIndex) => {
        const active = cardIndex === safeIndex;
        card.classList.toggle('is-az-active', active);
        if (active) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === safeIndex;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      this.previousButton.disabled = safeIndex === 0;
      this.nextButton.disabled = safeIndex === this.cards.length - 1;
    }

    goTo(index) {
      const safeIndex = clamp(index, 0, this.cards.length - 1);
      if (!this.isDesktop) {
        this.cards[safeIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        return;
      }

      const fraction = this.cards.length > 1 ? safeIndex / (this.cards.length - 1) : 0;
      const rootTop = this.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: rootTop - this.pinTop + fraction * this.travel,
        behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
      });
    }
  }

  if (!customElements.get('az-book-journey')) {
    customElements.define('az-book-journey', AzBookJourney);
  }

  const upgrade = (section) => {
    if (!section || section.tagName.toLowerCase() === 'az-book-journey') return;

    const journey = document.createElement('az-book-journey');
    Array.from(section.attributes).forEach((attribute) => {
      if (attribute.name === 'style' || attribute.name === 'data-az-scroll-mounted') return;
      journey.setAttribute(attribute.name, attribute.value);
    });
    journey.classList.remove('az-scroll-stage');
    journey.innerHTML = section.innerHTML;
    journey.querySelectorAll('.az-scroll-meter').forEach((meter) => meter.remove());
    journey.querySelectorAll(CARD_SELECTOR).forEach((card) => card.removeAttribute('style'));
    section.replaceWith(journey);
  };

  const init = (root = document) => {
    if (root.matches?.(SOURCE_SELECTOR)) upgrade(root);
    root.querySelectorAll?.(SOURCE_SELECTOR).forEach(upgrade);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

